
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Getting Involved`}</h1>
    <p>{`At OpenABA, we are a small team of passionate volunteers united on the mission to create the best and most accessible ABA technology. Our line of work too often suffers with subpar tooling; we are here to change that for good. Thanks to our diverse team of ABA and software volunteers, we believe we are doing just that.`}</p>
    <p>{`If you are interested in getting involved in the OpenABA project, please
reach out to use `}<a href="mailto:volunteer@openaba.com"><a parentName="p" {...{
          "href": "mailto:volunteer@openaba.com"
        }}>{`volunteer@openaba.com`}</a></a>{`. We can use all the help we can get.`}</p>
    <p>{`Thank you,`}</p>
    <p>{`The OpenABA Team`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;